import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  displayHorizontal: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  displayHorizontalException: {
    flex: 0,
    flexBasis: 160,
  },
});
